__turbopack_context__.v({
  "innerContainer": "fIzYHG_innerContainer",
  "item": "fIzYHG_item",
  "list": "fIzYHG_list",
  "outerContainer": "fIzYHG_outerContainer",
  "scroller": "fIzYHG_scroller",
});
